import { z } from "zod";
export var Color;
(function (Color) {
    Color["DARK_AQUA"] = "dark-aqua";
    Color["DARK_BLUE"] = "dark-blue";
    Color["DARK_GREEN"] = "dark-green";
    Color["DARK_GREY"] = "dark-grey";
    Color["DARK_PURPLE"] = "dark-purple";
    Color["DARK_YELLOW"] = "dark-yellow";
    Color["DEFAULT_RED"] = "default-red";
    Color["LIGHT_AQUA"] = "light-aqua";
    Color["LIGHT_BLUE"] = "light-blue";
    Color["LIGHT_GREEN"] = "light-green";
    Color["LIGHT_GREY"] = "light-grey";
    Color["LIGHT_PURPLE"] = "light-purple";
    Color["LIGHT_YELLOW"] = "light-yellow";
    Color["MEDIUM_GREY"] = "medium-grey";
})(Color || (Color = {}));
export const AllColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
    Color.DARK_AQUA,
    Color.LIGHT_GREY,
    Color.DARK_GREY,
    Color.MEDIUM_GREY,
];
export const Colors = z.enum(AllColors);
//# sourceMappingURL=colors.js.map